import React from 'react';
import styled from '@emotion/styled';
import PhysicalSetBlock from '../../common/PhysicalSetBlock';

import PageTitle from '../../../common/PageTitle';
import Button from '../../../common/Button';
import { getYandexStoreImageMin } from '../../../../helpers';

const Wrapper = styled('div')`
  .set-block {
    margin-left: 42px;
    margin-top: 10px;
    padding-bottom: 15px;
    cursor: pointer;
    color: #7e57c2;
  }

  .current-product {
    display: flex;
    align-items: center;
    margin-top: 15px;
    margin-left: 42px;

    .image-block {
      width: 45px !important;
      height: 45px !important;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      margin-right: 10px;
    }

    .product-name {
      color: #343a40;
      font-weight: bold;
      max-width: 300px;

      .ids-span {
        font-size: 11px;
        color: #98a6ad;
        cursor: pointer;
        font-weight: normal;
      }
    }
  }
`;

const DesktopComponent = ({
  currentProduct,
  data,
  handleUpdatePhysicalSet,
  handleSavePhysicalSet,
  handleChooseProduct,
  loading,
  physicalSet,
}) => {
  return (
    <>
      <PageTitle title="Новый комплект" />

      <Wrapper className="card">
        <div className="card-body">
          <div className="form-inline">
            <div className="form-group">
              <span className="number-circle mr-2">1</span>
              <span>Выберите товар</span>
            </div>
          </div>

          {currentProduct ? (
            <div className="current-product">
              <div
                className="image-block"
                style={{
                  backgroundImage: `url(${getYandexStoreImageMin(
                    currentProduct?.images?.[0]?.url,
                    100,
                  )})`,
                }}
              />
              <div className="product-name">
                <div>{currentProduct.shortName}</div>
                <span className="ids-span">
                  {currentProduct.id}
                  {currentProduct?.extId ?? null}
                </span>
              </div>
            </div>
          ) : null}

          <div className="set-block" onClick={handleChooseProduct}>
            {`${currentProduct ? 'Изменить' : 'Выбрать'} товар`}
          </div>
          {currentProduct ? (
            <>
              <div className="form-inline">
                <div className="form-group">
                  <span className="number-circle mr-2">2</span>
                  <span>Укажите состав</span>
                </div>
              </div>
              <div>
                <PhysicalSetBlock
                  withoutWrapper
                  currentVariant={currentProduct}
                  data={data}
                  needAdditionalData
                  handleUpdateSkuSet={handleUpdatePhysicalSet}
                />
              </div>
            </>
          ) : null}
          {currentProduct && physicalSet ? (
            <Button
              text="Сохранить"
              loading={loading}
              disabled={loading}
              onClick={handleSavePhysicalSet}
            />
          ) : null}
        </div>
      </Wrapper>
    </>
  );
};

export default DesktopComponent;
